import localesEs from '@/views/Auth/i18n/localeEs';

const translations = {
  es: {
    ...localesEs.es,
    SEO_TITLE: 'Iniciar Sesión',
    SEO_DESCRIPTION: 'Inicia sesión y aprende nuevas habilidades hoy.',
    FORM_TITLE: 'Potencia tu talento',
    FORM_SUBTITLE: 'Para continuar, establece una contraseña para tu cuenta.',
    INPUT_EMAIL_LABEL: 'Correo',
    INPUT_EMAIL_HINT: 'Ingresa tu correo',
    INPUT_USERNAME_LABEL: 'Usuario',
    INPUT_USERNAME_HINT: 'Ingresa tu usuario',
    INPUT_DNI_LABEL: 'DNI',
    INPUT_DNI_HINT: 'Ingresa tu DNI',
    INPUT_PASSWORD_LABEL: 'Contraseña',
    INPUT_PASSWORD_HINT: 'Ingresa contraseña',
    FORGOT_PASSWORD: '¿Olvidaste la contraseña?',
    BUTTON_SUBMIT_LABEL: 'Inicia sesión',
    BUTTON_SUBMIT_EMAIL: 'Confirmar correo',
    SOCIAL_LABEL: 'Inicia sesión con:',
    EMAIL_FORM_DESCRIPTION:
      'Asigna un email a tu cuenta para poder completar la configuración',
    CHANGE_PASSWORD_ERROR_MESSAGE:
      'Ocurrió un error al cambiar la contraseña. Por favor, intenta nuevamente.',
    LEARNING_SESSION_QUERY_ERROR:
      'Ocurrió un error al obtener la sesión de aprendizaje. Por favor, intenta nuevamente.',
    LEARNING_SESSION_NOT_FOUND:
      'No se encontró la sesión del usuario. Por favor contacta a tu administrador para asegurar que tu cuenta esté correctamente configurada.',
    RETRY: 'Reintentar',
    RELOAD_PAGE: 'Recargar página',
    CHANGE_PASSWORD_FORM_TITLE: 'Cambiar contraseña',
    CHANGE_PASSWORD_FORM_DESCRIPTION:
      'Tu administrador ha solicitado que actualices tu contraseña para cumplir con los requisitos de seguridad de la organización.',
    CHANGE_PASSWORD_FORM_INPUT_PASSWORD_LABEL: 'Crear contraseña',
    CHANGE_PASSWORD_FORM_INPUT_PASSWORD_HINT: 'Ingresa tu contraseña',
    CHANGE_PASSWORD_FORM_INPUT_CONFIRM_PASSWORD_LABEL: 'Confirmar contraseña',
    CHANGE_PASSWORD_FORM_INPUT_CONFIRM_PASSWORD_HINT: 'Confirma contraseña',
    CHANGE_PASSWORD_FORM_BUTTON_SUBMIT_LABEL: 'Confirmar contraseña',
    CHANGE_PASSWORD_FORM_BUTTON_SUBMIT_LABEL_LOADING: 'Cambiando contraseña...',
    PASSWORD_DOES_NOT_MATCH: 'Las contraseñas no coinciden',
    PASSWORD_CANNOT_CONTAIN_SPACES: 'La contraseña no puede contener espacios',
    CHANGE_PASSWORD_FORM_REQUIRED: 'Este campo es requerido',
    CHANGE_PASSWORD_FORM_MIN_LENGTH:
      'Tu contraseña debe tener al menos 6 caracteres',
    CHANGE_PASSWORD_FORM_MAX_LENGTH:
      'Tu contraseña no puede tener más de 50 caracteres',
    CHANGE_PASSWORD_STRENGTH_VERY_WEAK: 'Muy débil',
    CHANGE_PASSWORD_STRENGTH_WEAK: 'Débil',
    CHANGE_PASSWORD_STRENGTH_MEDIUM: 'Regular',
    CHANGE_PASSWORD_STRENGTH_STRONG: 'Fuerte',
    CHANGE_PASSWORD_STRENGTH_REQUIREMENTS_TITLE: 'Requisitos obligatorios',
    CHANGE_PASSWORD_STRENGTH_REQUIREMENT_TITLE_SINGULAR:
      'Requisito obligatorio',
    CHANGE_PASSWORD_STRENGTH_RETRY: 'Reintentar',

    // social auth buttons
    BUTTON_LABEL_LOGIN_WITH_GOOGLE_SIGN_IN: 'Ingresar con Google',
    BUTTON_LABEL_LOGIN_WITH_MICROSOFT_SIGN_IN: 'Ingresar con Microsoft',
    BUTTON_LABEL_LOGIN_WITH_MICROSOFT_SECURE_AUTH: 'Ingresar con SecureAuth',
    BUTTON_LABEL_LOGIN_WITH_OPENAGORA: 'Ingresar con Openagora',
  },
};

export default translations;
